export const colors = {
	mainText: '#495057',
	hoverText: '#000000f2',
	infoText: '#6c757d',
	secondaryText: '#906005',
	labelText: '#757575',

	border: '#dae0e5',
	tabsBorder: '#dee2e6',

	background: '#eaeaea',

	placeholder: '#98aabc'
};
